import { InfoTypeExposure } from "./models";
import { gql2, cord, formatInput } from "@/gql/lib";
import { InformationType, InfoTypeHelper } from "@/common/models";
import { ActionEnum, AxisType, CountParametersTier1Tier2 } from "@/gql/types";
import groupBy from "lodash.groupby";
import { SharedState } from "@/common/state";

// detection dashboard
export const getDashboardData = gql2<InformationType[], InfoTypeExposure[]>(
  "detection.get",
  (loTypes: InformationType[], timeFrames) => {
    const l0Ids = loTypes.map((l) => l.id);
    const q: CountParametersTier1Tier2 = {
      coordinate: {
        x: cord(AxisType.Severity, []),
        y: {
          type: AxisType.ContentLabel,
          values: loTypes.map((d) => d.id),
        },
        z: timeFrames.frame,
      },
      page: 0,
      pageSize: 1000,
      action: ActionEnum.List,
    };
    return {
      query: `{
        tier1count(params:${formatInput(q)}){
          count
          x{value}
          y{value}
        }
      }`,
      mapper: (res) => {
        const levels = ["none", "low", "medium", "high"];
        let { tier1count } = res;
        tier1count = tier1count
          .filter((r: any) => l0Ids.includes(r.y.value))
          .map((t: any) => {
            return {
              id: t.y.value,
              [levels[t.x.value]]: t.count,
            };
          });
        const f = groupBy(tier1count, "id");
        const g: { [key: string]: InfoTypeExposure } = {};

        for (const labelId in f) {
          g[labelId] = f[labelId].reduce(
            (acc: InfoTypeExposure, item: InfoTypeExposure) => {
              return { ...acc, ...item };
            },
            { high: 0, medium: 0, id: "?", low: 0 } as InfoTypeExposure
          );
        }
        const SEED = l0Ids.reduce((acc, id) => {
          acc[id] = { high: 0, medium: 0, id, low: 0 };
          return acc;
        }, {} as { [key: string]: InfoTypeExposure });

        const result = { ...SEED, ...g };
        return Object.values(result);
      },
    };
  }
);

export const get_pii_data = gql2<void, InfoTypeExposure[]>(
  "detection-regulated",
  (_, { frame }) => {
    const pii_categories_ids = SharedState.PII.L1().map(
      (d: InformationType) => d.id
    );
    const q: CountParametersTier1Tier2 = {
      coordinate: {
        x: { type: AxisType.Severity, values: ["1", "2", "3"] },
        y: {
          type: AxisType.ContentLabel,
          values: pii_categories_ids,
        },
        z: frame,
      },
      page: 0,
      pageSize: 1000,
      action: ActionEnum.List,
    };
    return {
      query: `{
      tier1count(params:${formatInput(q)}){
        count
        x{value}
        y{value}
      }
    }`,
      mapper: (res) => {
        const { tier1count } = res;
        const severities = ["_", "low", "medium", "high"];
        const result: InfoTypeExposure[] = pii_categories_ids.map((id) => {
          return {
            id,
            high: 0,
            medium: 0,
            low: 0,
          };
        });
        for (const item of tier1count) {
          const severity_level = +item.x.value;
          const label_id = item.y.value;
          // @ts-ignore
          result.find((f) => f.id == label_id)[severities[severity_level]] +=
            item.count;
        }
        return result;
      },
    };
  }
);

export const get_regulated_data = gql2<void, InfoTypeExposure[]>(
  "detection-regulated",
  (_, { frame, allInfoTypes }) => {
    const all_regulated_info = SharedState.typesByCategories.value.get(
      InfoTypeHelper.REGULATED_ID()
    ) as InformationType[];
    const q: CountParametersTier1Tier2 = {
      coordinate: {
        x: { type: AxisType.Severity, values: ["1", "2", "3"] },
        y: {
          type: AxisType.ContentLabel,
          values: all_regulated_info.map((d) => d.id),
        },
        z: frame,
      },
      page: 0,
      pageSize: 1000,
      action: ActionEnum.List,
    };
    return {
      query: `{
      tier2count(params:${formatInput(q)}){
        count
        x{value}
        y{value}
      }
    }`,
      mapper: (res) => {
        const { tier2count } = res;
        const exist = tier2count.filter(
          (s: any) => allInfoTypes[s.y.value] && s.x.value !== "0"
        );
        // @ts-ignore
        const reduced = exist.reduce((acc, item) => {
          const severity_level = +item.x.value;
          const label = allInfoTypes[item.y.value];
          console.log("label.content_code: ", label.content_code);
          if (acc[label.content_code as number]) {
            acc[label.content_code as number][severity_level] += item.count;
          } else {
            acc[label.content_code as number] = {
              id: label.content_code,
              0: 0,
              1: 0,
              2: 0,
              3: 0,
            };
            acc[label.content_code as number][severity_level] += item.count;
          }
          return acc;
        }, {});

        console.log("reduced::", reduced);

        const default_val = Array.from(
          new Set(all_regulated_info.map((d) => d.content_code))
        ).reduce((acc, code) => {
          // @ts-ignore
          acc[code] = {
            id: code,
            0: 0,
            1: 0,
            2: 0,
            3: 0,
          };
          return acc;
        }, {});

        return { ...default_val, ...reduced };
      },
    };
  }
);

const d = {
  tier2count: [
    {
      count: 2,
      x: {
        value: "1",
      },
      y: {
        value: "4fab503f-4528-6291-e667-db29d8c7011f",
      },
    },
    {
      count: 2,
      x: {
        value: "1",
      },
      y: {
        value: "e67d194b-abcd-a8ca-51e5-bdb38f738bf7",
      },
    },
    {
      count: 6,
      x: {
        value: "1",
      },
      y: {
        value: "73307a6d-74e8-635e-95cc-a13cd4d5785a",
      },
    },
    {
      count: 2,
      x: {
        value: "1",
      },
      y: {
        value: "2e5fe6b2-e12c-d475-bec8-dc7c5ed99961",
      },
    },
    {
      count: 1,
      x: {
        value: "1",
      },
      y: {
        value: "13c9a0eb-de1e-9c9f-7033-650f892033f0",
      },
    },
  ],
};
